






import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'KETextSection',
  props: {
    content: {
      type: String,
      default: ''
    }
  }
});
